import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  role: "list",
  class: "grid grid-cols-1 gap-4 lg:grid-cols-2"
}
const _hoisted_4 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_5 = { class: "flex-shrink-0 pl-4 pr-4 flex items-start justify-start" }
const _hoisted_6 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_7 = { class: "flex-shrink-0 pl-4 pr-4 flex items-start justify-start" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "pt-6 mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4" }

import { ref } from 'vue';
import HardwareSelectorProduct from './HardwareSelectorProduct.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { CheckCircleIcon as CheckCircleSolidIcon } from '@heroicons/vue/solid';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HardwareSelector',
  props: {
    products: {},
    isHardwareAdded: { type: Boolean },
    selected: {}
  },
  emits: ["onHardwareSelected", "onHardwareToggled"],
  setup(__props: any, { emit: __emit }) {


const props = __props;

const emit = __emit;

const hardwareProductAdded = ref(false);
const productSelected = ref<Product|null>();

const handleClickAddHardwareProduct = () => {
  hardwareProductAdded.value = true;
  emit('onHardwareToggled', true);
};

const handleClickRemoveHardwareProduct = () => {
  hardwareProductAdded.value = false;
  emit('onHardwareToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onHardwareSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark", [ hardwareProductAdded.value ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]])
        }, [
          _createElementVNode("div", {
            onClick: handleClickAddHardwareProduct,
            class: _normalizeClass(["transition duration-250 relative flex-1 flex items-center justify-between", [(hardwareProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-2xl transition duration-250 text-black font-poppins-bold", [hardwareProductAdded.value ? 'text-white' : 'text-black']])
              }, "Yes", 2)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (!hardwareProductAdded.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["text-right mr-2 w-7 h-7 text-white rounded-full border border-solid", [ hardwareProductAdded.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                  }, null, 2))
                : _createCommentVNode("", true),
              (hardwareProductAdded.value)
                ? (_openBlock(), _createBlock(_unref(CheckCircleSolidIcon), {
                    key: 1,
                    class: "text-right pr-2 w-8 h-8 text-white",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark", [ !hardwareProductAdded.value ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]])
        }, [
          _createElementVNode("div", {
            onClick: handleClickRemoveHardwareProduct,
            class: _normalizeClass(["transition duration-250 relative flex-1 flex items-center justify-between", [(!hardwareProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-2xl transition duration-250 text-black font-poppins-bold", [hardwareProductAdded.value ? 'text-black' : 'text-white']])
              }, "No", 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (hardwareProductAdded.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["text-right mr-2 w-7 h-7 text-white rounded-full border border-solid", [ !hardwareProductAdded.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                  }, null, 2))
                : _createCommentVNode("", true),
              (!hardwareProductAdded.value)
                ? (_openBlock(), _createBlock(_unref(CheckCircleSolidIcon), {
                    key: 1,
                    class: "text-right pr-2 w-8 h-8 text-white",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2)
      ]),
      (hardwareProductAdded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return (_openBlock(), _createBlock(HardwareSelectorProduct, {
                  onHandleSelectProduct: handleSelectProduct,
                  product: product,
                  key: product.name,
                  isSelectedProduct: isSelectedProduct(product)
                }, null, 8, ["product", "isSelectedProduct"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})